import { Injectable } from "@angular/core";
import { LessonCard } from "../../Models/lessons.interface";
import { LanguageSwitchService } from "../LanguageSwitch/language-switch.service";

@Injectable()
export class LessonManagerService {
  lessonsCards: Array<LessonCard>;
  constructor(private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.lessonsCards = config.lessonsCards;
      },
    });
  }

  getLessonCards(): Array<LessonCard> {
    var retLessons = JSON.parse(JSON.stringify(this.lessonsCards)); // break the reference before you return the object, aka, copy it, dont pass a reference
    return retLessons;
  }
  getCard(id: number): LessonCard {
    if (id > 0 && !(id > this.lessonsCards.length)) {
      return this.lessonsCards[id - 1];
    }
    return null;
  }
}
